module.exports = __webpack_public_path__ + "img/expand-06.c7d82a84.svg";